var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMoreSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.752 8H22.745C13.682 8 8 14.417 8 23.498V48.002C8 57.083 13.652 63.5 22.745 63.5H48.749C57.842 63.5 63.5 57.083 63.5 48.002V23.498C63.5 14.417 57.842 8 48.752 8Z",
    stroke: "#9BAEBC",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3106 39.3417C20.3276 39.3417 18.7166 37.7307 18.7166 35.7507C18.7166 33.7707 20.3276 32.1567 22.3106 32.1567C24.2936 32.1567 25.9046 33.7707 25.9046 35.7507C25.9046 37.7307 24.2936 39.3417 22.3106 39.3417",
    fill: "#9BAEBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7471 39.3417C33.7641 39.3417 32.1531 37.7307 32.1531 35.7507C32.1531 33.7707 33.7641 32.1567 35.7471 32.1567C37.7301 32.1567 39.3411 33.7707 39.3411 35.7507C39.3411 37.7307 37.7301 39.3417 35.7471 39.3417",
    fill: "#9BAEBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.187 39.3417C47.204 39.3417 45.593 37.7307 45.593 35.7507C45.593 33.7707 47.204 32.1567 49.187 32.1567C51.17 32.1567 52.781 33.7707 52.781 35.7507C52.781 37.7307 51.17 39.3417 49.187 39.3417",
    fill: "#9BAEBC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreSquare);
export default __webpack_public_path__ + "static/media/IconMoreSquare.b08b6dd8.svg";
export { ForwardRef as ReactComponent };